module.exports = __webpack_public_path__ + "img/A1.83388a11.png";